import {IngenieroAgronomoCore} from './ingenieros-agronomos-core.model';
import {DetailField} from '../../../shared/models/detail.model';
import {Persona} from '../persona/persona.model';

export const INGENIEROSAGRONOMOSCOREDETAIL_DEFAULT_FIELDS: DetailField[] = [
  // { name: 'cjppu', label: 'CJPPU' }
];

export interface IngenierosCoreDetailParams {
  ingeniero: IngenieroAgronomoCore;
  persona: Persona;
  fields?: DetailField[];
}
